import type { Dispatch, ReactNode, SetStateAction } from "react";

import { Minimize2, MoveDiagonal, X } from "lucide-react";

import { useFeedbackTool } from "@/features/request/feedback-tool/feedbackTool/hooks/useFeedbackTool.tsx";
import { useWindowDimensions } from "@/hooks/useScreenSize";

export function FeedbackModal({
  children,
  setOpen,
  setSize,
  size,
}: {
  children: ReactNode;
  setOpen: Dispatch<SetStateAction<boolean>>;
  setSize: Dispatch<SetStateAction<"FULL" | "MODAL">>;
  size: "FULL" | "MODAL";
}) {
  const { img, isTablet } = useFeedbackTool();
  const isPdf = img.url.includes(".pdf");
  const width = useWindowDimensions().width ?? 0;

  return (
    <div className="fixed bg-black/50 h-full w-full left-0 top-0 flex justify-center items-center z-[59]">
      <div
        className={`rounded-lg ${size === "MODAL" ? "min-w-250" : "w-full h-full animate-feedback"} bg-bg-primary`}
      >
        <div className="flex justify-between items-center pt-3 pb-1 pl-6 pr-6 mb-0 border-b border-border-secondary">
          <h1
            className="text-[20px] text-text-primary min-w-0 truncate"
            title={img.asset}
          >
            {img.asset}
          </h1>
          <div className="flex shrink-0">
            {isPdf || width < 1000 || isTablet ? null : size === "MODAL" ? (
              <MoveDiagonal
                className="text-fg-quinary mb-3 cursor-pointer bottom-0"
                onClick={() => {
                  setSize("FULL");
                }}
                size={24}
              />
            ) : (
              <Minimize2
                className="text-fg-quinary mb-3 cursor-pointer bottom-0"
                onClick={() => {
                  setSize("MODAL");
                }}
                size={24}
              />
            )}
            <X
              className="text-fg-quinary mb-3 ml-3 cursor-pointer"
              onClick={() => {
                setOpen(false);
              }}
              size={24}
            />
          </div>
        </div>
        {children}
      </div>
    </div>
  );
}
